/*
 * We need to create the minimum structure that mirrors the values selected
 *
 * valueFilters: ValueFilters TO apiFilters: ValueFilters
 *
 * This structure needs to preserve all keys that have present values
 * It will clear nulls and empty arrays and empty objects
 *
 * returns ValueFilters
 * */
import cloneDeep from "lodash/cloneDeep";
import isArray from "lodash/isArray";
import isEmpty from "lodash/isEmpty";
import { AvailabilityRule, Filters, Value } from "PFTypes";

export const getAPIFilters = (valueFilters: Filters<Value> | undefined): Filters<Value> | undefined => {
  const valueFiltersCopy = cloneDeep(valueFilters) || {};

  if (isEmpty(valueFilters)) {
    return undefined;
  }

  Object.keys(valueFiltersCopy).forEach((key) => {
    if (key === "availability") {
      const isAvailabilityWithEmptyRanges =
        key === "availability" && isEmpty((valueFiltersCopy[key] as AvailabilityRule)?.ranges);

      if (isEmpty(valueFiltersCopy[key]) || isAvailabilityWithEmptyRanges) {
        delete valueFiltersCopy[key];
      }

      return;
    }

    if (key === "children") {
      const childrenApiFilters = getAPIFilters(valueFilters.children);
      if (childrenApiFilters && !isEmpty(childrenApiFilters)) {
        valueFiltersCopy.children = childrenApiFilters;
      } else if (isEmpty(childrenApiFilters)) {
        delete valueFiltersCopy.children;
      }
      return;
    }

    const innerFilters = valueFiltersCopy[key];
    Object.keys(innerFilters).forEach((filterName) => {
      const value = innerFilters[filterName];

      if (
        (isArray(value) && isEmpty(value)) ||
        value == null || // eslint-disable-line eqeqeq
        value === ""
      ) {
        delete innerFilters[filterName];
      }
    });

    if (isEmpty(valueFiltersCopy[key])) {
      delete valueFiltersCopy[key];
    }
  });

  return valueFiltersCopy;
};
